import React from 'react';

const FormField = ({ field, onEdit, onDelete }) => {
  if (field.type === 'alert') {
    return null;
  }
  return (
    <div
      style={{
        border: '1px solid #ccc',
        padding: '15px',
        margin: '10px 0',
        position: 'relative',
      }}
    >
      <strong>{field.label}</strong>
      <div
        style={{
          position: 'absolute',
          right: '10px',
          top: '10px',
          display: 'flex',
          gap: '10px',
        }}
      >
        <button className="btn btn-sm btn-outline btn-info" onClick={onEdit}>
          Editar
        </button>
        <button className="btn btn-sm btn-outline btn-error" onClick={onDelete}>
          Eliminar
        </button>
      </div>
    </div>
  );
};

export default FormField;
